.icon-button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  color: var(--color-uva-black);
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: var(--font-size-default);
  gap: 0.25rem;
  height: 2.75rem;
  justify-content: center;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
  width: 2.75rem;
}

.icon-button:focus-visible {
  border-color: currentcolor;
}

.icon-button--destructive {
  color: var(--color-red-600);
}

.icon-button:hover:not(:disabled) {
  border-color: currentcolor;
}

.icon-button--no-border:focus-visible,
.icon-button--no-border:hover:not(:disabled) {
  background-color: var(--color-grey-300);
}

.icon-button--no-border:hover:not(:focus-visible, :disabled) {
  border-color: transparent;
}

.icon-button--wide {
  min-width: 2.75rem;
  padding: 0 0.75rem;
  width: unset;
}

.icon-button > svg {
  pointer-events: none;
}

.icon-button[disabled] {
  cursor: unset;
  opacity: 0.4;
}

/*
On displays without hover such as smart phones and tablets, make the tappable
area 0.5rem (8px) bigger in all directions.
*/
@media (hover: none) {
  .icon-button::after {
    bottom: -0.5rem;
    content: " ";
    left: -0.5rem;
    position: absolute;
    right: -0.5rem;
    top: -0.5rem;
  }
}
